"use strict";

exports.__esModule = true;
exports.ConditionTextFilter = void 0;
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _TranslatorContext = require("../../Core/Translator/TranslatorContext");
var _react = _interopRequireWildcard(require("react"));
var _CommonValidators = require("../utils/CommonValidators");
var _styles = require("../styles");
var _operators = require("./operators");
var _vimanaTypes = require("@vimana/vimana-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ConditionTextFilter = exports.ConditionTextFilter = function ConditionTextFilter(_ref) {
  var operator = _ref.operator,
    values = _ref.values,
    isOpen = _ref.isOpen,
    setOpen = _ref.setOpen,
    setValues = _ref.setValues,
    setOperator = _ref.setOperator;
  var _useContext = (0, _react.useContext)(_TranslatorContext.TranslatorContext),
    translate = _useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
    "data-testid": "EnrichEditorUI.ClassifyConfig.TextFilterCheckbox",
    checked: isOpen,
    onChange: function onChange(_ref2) {
      var checked = _ref2.currentTarget.checked;
      setOpen(checked);
    }
  }, translate("EnrichEditorUI.ConditionClassify.ConditionTextFilter", "Condition text filter")), isOpen ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.FlexRow, null, /*#__PURE__*/_react["default"].createElement("span", null, translate("EnrichEditorUI.ConditionClassify.Operator", "Operator")), /*#__PURE__*/_react["default"].createElement(_styles.Spacer, null), /*#__PURE__*/_react["default"].createElement(_Core.Selector, _extends({
    dataTestId: "EnrichEditorUI.ClassifyConfig.TextFilterSelector",
    items: _operators.CONDITION_TEXT_OPERATORS,
    getKey: function getKey(operator) {
      return operator.value;
    },
    renderItemText: function renderItemText(operator) {
      return operator.displayName;
    },
    selected: operator && [operator],
    onSelect: function onSelect(_ref3) {
      var newOperator = _ref3[0];
      return setOperator(newOperator);
    }
  }, !(0, _CommonValidators.validateSelector)(operator) && {
    style: Object.assign({}, true && {
      border: "solid 1px red"
    })
  }, {
    itemPredicate: function itemPredicate(query, item) {
      return item.value.toLowerCase().indexOf(query.toLowerCase()) !== -1 || item.displayName.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    }
  }))), values && values.map(function (value, i, a) {
    return /*#__PURE__*/_react["default"].createElement(_styles.Row, {
      key: value
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        whiteSpace: "nowrap"
      }
    }, i === 0 ? translate("EnrichEditorUI.ConditionClassify.TextList", "Text list") : ""), /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
      "data-testid": "EnrichEditorUI.ClassifyConfig.ConditionTextFilterInput"
    }, !(0, _CommonValidators.validateEmptyField)(value) && {
      intent: _core.Intent.DANGER
    }, {
      value: value,
      onChange: function onChange(_ref4) {
        var target = _ref4.target;
        var newValues = values.slice();
        newValues[i] = target.value;
        setValues(newValues);
      }
    })), /*#__PURE__*/_react["default"].createElement(_styles.ClassifyAddButtonsContainer, null, i === 0 ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "EnrichEditorUI.ClassifyConfig.AddCondition",
      icon: "plus",
      intent: _core.Intent.PRIMARY,
      onClick: function onClick() {
        return setValues(values.concat([""]));
      }
    }) : /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "DeleteRow",
      icon: "minus",
      onClick: function onClick() {
        a.splice(i, 1);
        setValues(a);
      }
    })));
  }), !(0, _CommonValidators.validateNumberOfValues)(values) ? /*#__PURE__*/_react["default"].createElement(_styles.Row, null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: "rgb(194, 48, 48)"
    }
  }, translate("EnrichEditorUI.ClassifyConfig.Validation.ValuesRequired", "At least one value is required"))) : null) : null);
};